import { render, staticRenderFns } from "./CardDoesntFind.vue?vue&type=template&id=f38a2d78"
import script from "./CardDoesntFind.vue?vue&type=script&lang=js"
export * from "./CardDoesntFind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports